import { LogEntry, useAuditLogs, useAuditResourceService } from 'api/audit'
import * as R from 'ramda'
import React, { useEffect, useState } from 'react'
import { Panel } from './fragments/comp/panel'
import moment from 'moment'
import { TransactionsTable } from './payments'
import { AccountsCache, TransactionList, usePaymentsAPI } from './api/payments-api'

export default function SupportLogs(props: { orderId: string }): JSX.Element {
  const api = useAuditResourceService()
  const { logs } = useAuditLogs(100)
  const [localMessages, setLocalMessages] = useState<LogEntry[]>([])
  const [message, setMessage] = useState('')
  const onSend = () => {
    if (message.length) api.createLog('ChatMessage', message).then((msg) => setLocalMessages([msg, ...localMessages]))
  }

  const paymentsAPI = usePaymentsAPI()

  const [transactions, setTransactions] = useState<TransactionList | null>()
  const [accounts, setAccounts] = useState<AccountsCache>({})

  useEffect(() => {
    paymentsAPI.findOrderTransactions(props.orderId).then(setTransactions)
  }, [props.orderId])

  useEffect(() => {
    if (transactions) {
      const accounts = new Set<number>()
      transactions.transactions.reduce((sum, { credit_account_id, debit_account_id }) => {
        sum.add(credit_account_id)
        sum.add(debit_account_id)
        return sum
      }, accounts)
      Promise.all([...accounts].map(paymentsAPI.loadAccount)).then((res: Account[]) => {
        setAccounts(res.reduce((sum, a) => R.assoc('' + a.id, a, sum), {}))
      })
    }
  }, [transactions])

  return (
    <Panel id="audit" label="Support Messages" fullHeight={false}>
      <ul>
        {localMessages.map((l: LogEntry, index: number) => (
          <LogEntryRow key={`local-${index}`} {...l} accounts={accounts} />
        ))}
        {logs.map((l: LogEntry) => (
          <LogEntryRow key={l.id} {...l} accounts={accounts} />
        ))}
      </ul>

      <div className="textarea">
        <textarea
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          rows={3}
          placeholder="enter new message and click on Send button"
          style={{ width: '100%' }}
        />
        <br />
        <button className="btn btn-primary pull-right" disabled={message.length == 0} onClick={onSend}>
          Send
        </button>
      </div>
    </Panel>
  )
}

function LogEntryRow(props: LogEntry & { accounts: AccountsCache }) {
  switch (props.action) {
    case 'CreateTransactions':
      const transactions = JSON.parse(props.description)
      return (
        <li>
          On {moment(props.inserted_at).format('lll')}, {props.agent} created these transactions:
          <br />
          <TransactionsTable transactions={transactions} accounts={props.accounts} />
        </li>
      )
    case 'CreateFullRefund':
      return (
        <li>
          On {moment(props.inserted_at).format('lll')}, {props.agent} fully refunded :
          <br />
          <em>Reason: {props.description}</em>
        </li>
      )
    case 'CreateFullRefundChargeProvider':
      return (
        <li>
          On {moment(props.inserted_at).format('lll')}, {props.agent} fully refunded and charged delivery provider:
          <br />
          <em>Reason: {props.description}</em>
        </li>
      )
    default:
      return (
        <li>
          On {moment(props.inserted_at).format('lll')}, {props.agent} wrote:
          <br />
          <em>{props.description}</em>
        </li>
      )
  }
}
